import React, { useEffect, useState, useContext } from 'react';
import ModuleTitle from '../../../module-title';
import apis from '../../../../apis';
import ListCard from './list-card';
import ProviderUserTypeInfo from '../../../../provider-userType-info';
import './index.less';

const RankingList = (props) => {
  const [data, setData] = useState();
  const value = useContext(ProviderUserTypeInfo);
  const [conditions, setConditions] = useState({});
  useEffect(() => {
    setConditions((conditions) => Object.assign({}, conditions, { ...props.param }, { ...value }));
  }, [props.param, value]);
  useEffect(() => {
    if (!conditions.planCode) return;
    apis.queryTopRankInfo(conditions).then((res) => {
      const { ret, data } = res;
      if (ret === '0') {
        setData(data);
      }
    });
  }, [conditions]);
  return (
    <div className="participant-ranking-list-bg ">
      {data && (
        <ModuleTitle
          title="引入商详UV排行榜"
          hovertext="分各维度的引入商详UV排行榜，如TOP店铺：即在本次活动中引入商详UV排名top5的店铺"
        >
          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            <ListCard data={data.shop} title="店铺TOP5排行榜" name="店铺名称" />
            <ListCard data={data.brand} title="品牌TOP5排行榜" name="品牌名称" />
            <ListCard data={data.cate3} title="三级品类TOP5排行榜" name="三级品类名称" />
            <ListCard data={data.band} title="价格带TOP5排行榜" name="价格带名称" />
            <ListCard data={data.activity} title="会场TOP5排行榜" name="会场名称" />
            <ListCard data={data.sku} title="商品TOP5排行榜" name="商品名称" />
          </div>
        </ModuleTitle>
      )}
    </div>
  );
};
export default RankingList;
